import React from 'react'

type Props = {
  width?: number
  height?: number
  className?: string
}

const DiscoLogo = ({ width = 152, height = 31, className }: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 1292.31 261.98"
    fill="currentColor"
    className={className}
  >
    <polygon points="102.35 0 37.02 87.33 83.88 87.33 18.56 174.65 65.32 174.65 0 261.98 118.3 261.98 183.59 174.65 136.84 174.65 202.15 87.33 155.31 87.33 220.61 0 102.35 0" />
    <path d="M405.68,26.34h-72.51l-44.47,209.59h89.5c78.45,0,130-44.75,130-116.97,0-51.55-39.09-92.62-102.53-92.62ZM380.47,188.06h-25.49l24.07-113.86h19.83c36.54,0,52.96,23.51,52.96,48.72,0,38.8-30.87,65.14-71.37,65.14Z" />
    <polygon points="560.03 26.34 515.57 235.93 571.36 235.93 615.83 26.34 560.03 26.34" />
    <path d="M716.94,21.53c-51.55,0-81,31.44-81,71.09,0,23.79,13.88,42.77,41.07,52.96l32.29,12.46c9.06,3.68,14.44,10.2,14.44,17.84,0,12.75-9.91,20.96-24.92,20.96-15.86,0-30.87-7.65-32.85-24.92h-53.25c-2.27,47.02,39.37,68.82,86.38,68.82s80.72-24.64,80.72-68.82c0-27.19-16.71-47.02-45.6-58.06l-28.04-10.76c-9.35-3.68-13.88-10.2-13.88-17.56,0-11.61,9.35-19.54,22.94-19.54,16.43,0,26.06,6.51,26.91,22.94h52.4c2.83-45.6-33.14-67.41-77.6-67.41Z" />
    <path d="M931.77,70.24c27.76,0,48.43,18.13,52.4,42.77h56.65c-1.98-56.36-48.43-91.77-106.49-91.77-71.37,0-126.32,54.66-126.32,120.37,0,57.21,46.73,98.85,109.33,98.85,58.63,0,103.94-37.95,116.69-90.35h-57.21c-9.06,24.64-31.72,41.63-57.78,41.63-32,0-54.1-24.64-54.1-54.38,0-37.39,32.01-67.12,66.84-67.12Z" />
    <path d="M1183.27,21.81c-73.64,0-126.89,54.1-126.89,119.8,0,58.34,48.72,98.85,108.76,98.85,73.64,0,127.17-54.38,127.17-120.09,0-58.35-49.28-98.56-109.04-98.56ZM1167.69,191.74c-31.72,0-54.66-24.64-54.66-54.1,0-37.39,32.57-67.12,67.69-67.12,32.01,0,54.38,24.36,54.38,54.66,0,36.54-32.29,66.56-67.41,66.56Z" />
  </svg>
)

export default DiscoLogo
